export const barPreviewTitles = new Set([
  'Variação acumulada do ano (comparação anual)',
  'Variação mensal (ano contra ano)',
  'Tendência do mês atual (comparação anual)',
  'Variação mês a mês',
  'Tendência do mês atual (comparação sequencial)',
])
